'use client';

import { ExploreRounded, HomeRounded } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useTranslations } from 'next-intl';

import { ErrorPageLayout } from '@/components/errors/ErrorPageLayout';
import { Link } from '@/configurations/i18n/navigation';

export default function NotFound() {
    const t = useTranslations('notFound');

    return (
        <ErrorPageLayout
            code="404"
            title={t('title')}
            description={t('description')}
            actions={
                <>
                    <Button
                        component={Link}
                        href="/"
                        variant="contained"
                        size="large"
                        startIcon={<HomeRounded />}
                    >
                        {t('backHome')}
                    </Button>
                    <Button
                        component={Link}
                        href="/"
                        variant="outlined"
                        size="large"
                        startIcon={<ExploreRounded />}
                    >
                        {t('exploreDestinations')}
                    </Button>
                </>
            }
        />
    );
}
